import { render, staticRenderFns } from "./ProjectsSidebar.vue?vue&type=template&id=1deb5d74&scoped=true&lang=html&"
import script from "./ProjectsSidebar.vue?vue&type=script&lang=js&"
export * from "./ProjectsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsSidebar.vue?vue&type=style&index=0&id=1deb5d74&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deb5d74",
  null
  
)

export default component.exports